import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {WithSeparator} from '../WithSeparator/WithSeparator';
import {TextsWithSeparatorProps} from './TextsWithSeparatorProps.interface';

export function TextsWithSeparator({
  texts,
  separatorType,
  separatorStyle,
  separatorClassName,
  useStaticDot,
  className,
  ...props
}: TextsWithSeparatorProps) {
  const textArr = texts ? (Array.isArray(texts) ? texts : [texts]) : undefined;

  return (
    <div
      className={twMerge('line-clamp-1 text-ellipsis', className)}
      {...props}
    >
      {textArr && textArr.length > 0 && (
        <WithSeparator
          separatorType={separatorType}
          separatorClassName={separatorClassName}
          separatorStyle={separatorStyle}
          useStaticDot={useStaticDot}
        >
          {textArr.map((text, index) => (
            <Text
              key={`separator_text_${index}`}
              className="break-all align-middle"
            >
              {text}
            </Text>
          ))}
        </WithSeparator>
      )}
    </div>
  );
}
